import { PAYOUT_STATUSES } from '@pages/Payouts/constants';

import { orderStatusesFromMapping } from '../utils/stats';
import type {
  NormalizedPayoutStatus,
  PayoutStatsBackend,
  NormalizedPayoutStats
} from '../utils/types';

export function adaptPayoutResponse(
  statsResponse: PayoutStatsBackend | null | undefined
): NormalizedPayoutStats {
  const totalCount = statsResponse?.meta?.count ?? 0;
  const statuses: NormalizedPayoutStatus[] = statsResponse?.data ?? [];
  const statusItems = orderStatusesFromMapping(PAYOUT_STATUSES, statuses);
  return { totalCount, statuses, statusItems };
}
